<section class="stickeySection__">
  <section class="filter_section_" *ngIf="!isBookingLoader">
  <div class="top_header_">
    <p>
      <!-- Search Results: <span *ngIf="!(loaderService.isLoading | async)">{{this.list?.totalresults}}</span> -->
      <span>Choose your Preferred Flight:</span> <ng-container *ngIf="!(loaderService.isLoading | async)">&nbsp;<span>From</span> {{this.trip_type?.search_request?.origin?.city_name}} <span>To</span> {{this.trip_type?.search_request?.destination?.city_name}}</ng-container>
    </p>
    <div class="space"></div>
    <ng-container *ngIf="!router.url.includes('/cheap-flights')">
      
      <button  (click)="toggleFilterVisibility()"  mat-button color="primary" [disabled]="list?.totalresults === 0" *ngIf="this.list?.totalresults !== 0 && this.flight_list.length !== 0">
        <mat-icon color="primary">filter_alt</mat-icon> Filter
      </button>
    </ng-container>
  </div>
  <ng-container *ngIf="filter">
    <mat-card class="matcardWrapper"  *ngIf="isCardVisible">
      <div class="inner_card_wrapper_ filterDesign_">
        <button mat-icon-button color="primary"  class="showOnMd" (click)="toggleCardVisibility()"><mat-icon>close</mat-icon></button>
        <div class="filter_header">
          <h4>Price</h4>
          <div class="filter_amount_">
            <ngx-slider [(value)]="minValue" [(highValue)]="maxValue" [options]="options" (userChangeEnd)="onValueChange($event)"></ngx-slider>
            <div class="price_value">
              <p><span>{{minValue  * this.Xchangerates.getCurrency().rate | globalCurrency: this.Xchangerates.getCurrency().shortname}}</span><span>{{maxValue  * this.Xchangerates.getCurrency().rate | globalCurrency: this.Xchangerates.getCurrency().shortname}}</span></p>
            </div>
            <div class="filter_stops">
              <p>Stops:</p>
              <ul>
                <li *ngFor="let list of stops; let i = index" [value]="list" (click)="selectStop(list)" [class.active]="activeStates[i].isSelected">{{list.value}}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="inner_card_wrapper_ filterDesign_">
        <div class="filter_header">
          <h4>Depart Time</h4>
        </div>
        <div class="time_list_item">
          <ul>
            <ng-container *ngFor="let item of flightTime">
              <li (click)="selectDepart(item)" [class.active]="item.isSelected">
                <div class="time_layout_">
                  <div class="img_icon">
                    <img [src]="item.imgIcon" [alt]="item.name" class="img-fluid">
                  </div>
                  <p>{{item.time}}</p>
                </div>
              </li>
            </ng-container>
          </ul>
        </div>
      </div>
      <div class="inner_card_wrapper_ filterDesign_">
        <div class="filter_header">
          <h4>Arrive Time</h4>
        </div>
        <div class="time_list_item">
          <ul>
            <ng-container *ngFor="let item of flightTimeArr">
              <li  (click)="selectArrival(item)" [class.active]="item.isSelected_">
                <div class="time_layout_">
                  <div class="img_icon">
                    <img [src]="item.imgIcon" [alt]="item.name" class="img-fluid">
                  </div>
                  <p>{{item.time}}</p>
                </div>
              </li>
            </ng-container>
          </ul>
        </div>
      </div>
      <div class="inner_card_wrapper_ filterDesign_">
        <div class="filter_header">
          <h4>Airlines</h4>
        </div>
        <div class="flight_list_">
          <ul>
            <li *ngFor="let item of uniqueCarrierNames | slice:0:7">
              <mat-checkbox color="primary" [checked]="item.isSelected" (change)="filter_airline(item)">{{item.name}}</mat-checkbox>
            </li>
            <li *ngIf="uniqueCarrierNames.length > 7" class="view_more_btn">
              <button mat-button color="primary" (click)="airlinelist(uniqueCarrierNames)">View More</button>
            </li>
          </ul>
        </div>
      </div>
    </mat-card>
  </ng-container>
  </section>
  <ng-container *ngIf="!isLoading">
  <section class="DynamicCalandarPrice" *ngIf="!isBookingLoader">
    <ng-container *ngIf="this.list?.totalresults !== 0 && this.flight_list.length !== 0">
      <owl-carousel-o [options]="dynamicCalander">
        <ng-container *ngFor="let item of listCalandarPrice; let d = index">
          <ng-template carouselSlide>
            <mat-card class="CalandarPrice" [ngClass]="{'currentDate': item.active}" (click)="currentDate(item.date)">
              <div class="price_">
                <p class="date">{{item.date | date : 'mediumDate' }}</p>
                <p class="time">{{ (item.price === '0' ? '--' : (item.price * Xchangerates.getCurrency()?.rate) | globalCurrency:Xchangerates.getCurrency()?.shortname) }}</p>
              </div>
            </mat-card>
          </ng-template>
        </ng-container>
      </owl-carousel-o>
    </ng-container>
  </section>
  </ng-container>
  <section class="shorting_section" *ngIf="!isBookingLoader">
  <div class="shoting_">
    <div class="list_shorting list_">
      <p>Sort By:</p>
    </div>
    <div class="list_shorting list_">
      <div class="timing_shorting_">
        <div class="list_ list_"><button mat-button (click)="sortBy('departure')">Departure Time</button></div>
        <div class="list_ list_Duration"><button mat-button (click)="sortBy('duration')">Duration</button></div>
        <div class="list_ list_Arrive"><button mat-button (click)="sortBy('arrive')">Arrive Time</button></div>
      </div>
    </div>
    <div class="list_shorting list_">
      <button mat-button (click)="sortBy('price')">Price</button>
    </div>
    <div class="list_shorting list_"></div>
  </div>
  </section>
</section>
<section class="list_flight_section_ oneWay_list_section">
  <app-no-flight *ngIf="filterApplied && flight_list.length === 0"></app-no-flight>
  <app-flight-result-way  *ngIf="isLoading"></app-flight-result-way> <!--*ngIf="loaderService.isLoading | async"-->
  <app-flight-result-loader *ngIf="isBookingLoader"></app-flight-result-loader>
  <ng-container> <!--*ngIf="!(loaderService.isLoading | async)"-->
  <ng-container *ngIf="this.list?.totalresults === 0 && this.flight_list.length === 0">
    <app-no-flight></app-no-flight>
  </ng-container>
    <ng-container *ngFor="let item of flight_list;let i = index"> <!--filteredFlightList$ | async-->
      <mat-card class="matCard_flight_list"  *ngIf="item.name === 'flight'">
        <div class="_flight_list">
          <div class="flight_list">
            <div class="iconContent">
              <img src="https://air.belairtrip.com/img/air_logos/{{item['flightlegs'][0][0].carrier}}.png" [alt]="item['flightlegs'][0][0].carriername" class="img-fluid" onError="this.src='../../../../assets/b2c/flight/flight_icon.png'"/>
              <div class="content">
                <h4>{{item['flightlegs'][0][0].carriername | truncate:20}}</h4>
                <p><ng-container *ngFor="let carrNo of item['flightlegs'][0]">{{carrNo.carrier}}-{{carrNo.flightnumber}}&nbsp;</ng-container></p>
              </div>
            </div>
          </div>
          <div class="flight_list">
            <div class="timing_flight_">
              <div class="list_ list_Depart">
                <p class="time">{{item['flightlegs'][0][0].deptime | hourMinute}}</p>
                <!-- <p class="cityDate">{{item['flightlegs'][0][0].depdate}}</p> -->
                <p class="cityName">{{item['flightlegs'][0][0].origin_name}}</p>
              </div>
              <div class="list_ list_Duration">
                <div class="duration">
                  <p class="timeDuration">{{item | addLayoverDuration | formatTime}}</p>
                  <div class="distpoint">
                    <span class="line"></span>
                    <ng-container *ngFor="let list of item['flightlegs'][0]">
                      <span></span>
                    </ng-container>
                  </div>
                  <p class="stopage">
                    <ng-container *ngIf="item.layovers[0].length !== 0">{{item['flightlegs'][0].length - 1}} stop via</ng-container>
                    <ng-container *ngFor="let list of item.layovers[0] | keyvalue">
                      <ng-container>&nbsp;{{list.key}}</ng-container>
                    </ng-container>
                    <ng-container *ngIf="item.layovers[0].length === 0">Direct Flight</ng-container>
                  </p>
                </div>
              </div>
              <div class="list_ list_Arrive">
                <p class="time">{{item['flightlegs'][0][item['flightlegs'][0].length - 1].arrtime | hourMinute}}</p>
                <!-- <p class="cityDate">{{item['flightlegs'][0][item['flightlegs'][0].length - 1].arrdate}}</p> -->
                <p class="cityName">{{item['flightlegs'][0][item['flightlegs'][0].length - 1].destination_name}}</p>
              </div>
            </div>
          </div>
          <div class="flight_list">
            <p class="flight_fare">{{ item.multifares[0].flightfare.totalnet * this.Xchangerates.getCurrency().rate | globalCurrency: this.Xchangerates.getCurrency().shortname }}</p> <!--.multifares[0] For Multifare api-->
            <!-- <button mat-button class="view_Fairs__" color="primary"  (click)="flightInfo__(i)">{{ flight_Details__[i] ? 'Hide Prices' : 'View Prices' }}</button> -->
          </div>
          <div class="flight_list">
            <button mat-button class="bookingButton" color="primary" (click)="submit(item, item.multifares[0])" *ngIf="item.multifares?.length === 1">Book Now</button>
            <button mat-button class="bookingButton" color="primary" (click)="flightInfo__(item)" *ngIf="item.multifares?.length !== 1">{{ flight_Details__[i] ? 'Hide Prices' : 'View Prices' }}</button>
          </div> <!--(click)="submit(item)"    Book Now // // (click)="flightInfo__(i)">{{ flight_Details__[i] ? 'Hide Prices' : 'View Prices' }} Multifare-->
        </div>
        <div class="moreInfoFlight">
          <div class="more_info_details">
            <ul>
              <li class="meal_info_" *ngIf="(item | extractValidatingCarrier)?.includes('AI')"><span> <mat-icon>restaurant</mat-icon>Complimentary Meals</span></li>
            </ul>
            <!-- <ul *ngIf="item.extra_info.length !== null">
              <li><span *ngIf="item.extra_info.hand_baggage.length > 0"> <ng-container *ngIf="item.extra_info.hand_baggage[0].value === true"><mat-icon>business_center</mat-icon>Allow&nbsp;Hand Baggage</ng-container></span><span class="non_refundable" *ngIf="item.extra_info.hand_baggage.length === 0"><mat-icon>work_off</mat-icon>No Hand Baggage</span></li>
              <li><span *ngIf="item.extra_info.baggage.length > 0"><mat-icon>luggage</mat-icon>{{item.extra_info.baggage[0].value}}&nbsp;Check In Baggage</span><span *ngIf="item.extra_info.baggage.length === 0"><mat-icon>no_luggage</mat-icon>No Baggage</span></li>
              <li class="fundInfo" ngClass="{{item.extra_info.refundable === true ? 'refundable' : item.extra_info.refundable === false ? 'non_refundable' : item.extra_info.refundable}}" (click)="flightInfo(i)">
                {{item.extra_info.refundable === true ? 'REFUNDABLE' : item.extra_info.refundable === false ? 'NON REFUNDABLE' : item.extra_info.refundable}}
              </li>
            </ul> -->
          </div>
          <div class="space"></div>
          <button mat-button class="flight_detatils" (click)="flightInfo(i)">{{ flight_Details[i] ? 'Hide' : 'View' }}&nbsp;Flight Details</button>
        </div>
        <section class="moreInformationFlight" [ngClass]="{'d-block': flight_Details[i]}">
          <div class="wrapperFlight">
            <div class="innerWrapper">
              <div class="flight_deatils_info">
                <h3>Flight Details</h3>
                <div class="more_flight_details">
                  <ng-container *ngFor="let listItem of item['flightlegs'][0]">
                    <div class="flight_header_">
                      <div class="flight_info_">
                        <div class="iconContent">
                          <img src="https://air.belairtrip.com/img/air_logos/{{listItem.carrier}}.png" [alt]="listItem.carriername" class="img-fluid" onError="this.src='../../../../assets/b2c/flight/flight_icon.png'"/>
                          <div class="content">
                            <h4>{{listItem.carriername| truncate:20}}</h4>
                            <p>{{listItem.carrier}}-{{listItem.flightnumber}}&nbsp;</p>
                          </div>
                        </div>
                      </div>
                      <div class="more_info_extra">
                        <ng-container *ngIf="this.urlDomastics.type === 'domestic'"><p class="mb-1"><span><mat-icon>business_center</mat-icon><!--{{item.extra_info.hand_baggage[0].value}}--><strong>Cabin Baggage:&nbsp;</strong>7Kg (1 Piece Only)/ Adult</span></p></ng-container>
                        <ng-container *ngIf="this.urlDomastics.type === 'international'"><p *ngIf="item.extra_info.hand_baggage.length > 0"><span><mat-icon>business_center</mat-icon><!--{{item.extra_info.hand_baggage[0].value}}--><strong>Cabin Baggage:&nbsp;</strong>7Kg (1 Piece Only)/ Adult</span></p></ng-container>
                        <p><span *ngIf="item.extra_info.baggage.length > 0"><mat-icon>luggage</mat-icon><strong>Check-in Baggage:&nbsp;</strong>{{item.extra_info.baggage[0].value | transformUnit}}/ Adult<!--&nbsp;Check In Baggage--></span></p>
                      </div> <!-- *ngIf="item.extra_info.hand_baggage.length > 0" --> <!--<span *ngIf="item.extra_info.baggage.length === 0"><mat-icon>no_luggage</mat-icon>No Baggage</span>-->
                    </div>
                    <div class="flight_body_">
                      <div class="timing_flight_">
                        <div class="list_ list_Depart">
                          <p class="cityName">{{listItem.origin_name}}</p>  <!--.slice(0,-5)-->
                          <p class="time">{{listItem.deptime | hourMinute}}</p>
                          <p class="cityDate">{{listItem.depdate | date: 'LLL, dd yyyy'}}</p>
                          <p class="terminal" *ngIf="listItem.depterminal !== ''">Terminal {{listItem.depterminal}}</p>
                        </div>
                        <div class="list_ list_Duration">
                          <div class="duration">
                            <img src="../../../../assets/belairtrip_assets/svg_icon/clockicon.svg" alt="" class="img-fluid clock">
                            <p class="timeDuration">{{listItem.journeyduration | formatTime}}</p>
                            <div class="distpoint">
                              <span class="line"></span>
                            </div>
                            <p class="stopage">
                              <!-- <ng-container *ngIf="item.layovers[0].length !== 0">{{item['flightlegs'][0].length - 1}} stop via</ng-container>
                              <ng-container *ngFor="let list of item.layovers[0] | keyvalue">
                                <ng-container>&nbsp;{{list.key}}</ng-container>
                              </ng-container>
                              <ng-container *ngIf="item.layovers[0].length === 0">Direct Flight</ng-container> -->
                            </p>
                          </div>
                        </div>
                        <div class="list_ list_Arrive">
                          <p class="cityName">{{listItem.destination_name}}</p> <!--.slice(0, -5)-->
                          <p class="time">{{listItem.arrtime | hourMinute}}</p>
                          <p class="cityDate">{{listItem.arrdate | date: 'LLL, dd yyyy'}}</p>
                          <p class="terminal" *ngIf="listItem.depterminal !== ''">Terminal {{listItem.arrterminal}}</p>
                        </div>
                      </div>
                    </div>
                    <!-- Layover -->
                    <ng-container *ngIf="listItem.stopover === true">
                      <div class="layover">
                        <ng-container *ngFor="let list of item.layovers[0] | keyvalue">
                          <ng-container *ngIf="list.key === listItem.destination">
                            <p>Flight change · Layover&nbsp;&nbsp;<span>{{this.util.convertToNumber(list.value) | secondsToDHM}}&nbsp;({{listItem.destination}})</span></p>
                          </ng-container>
                        </ng-container>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
            </div>
            <div class="innerWrapper fare_information">
              <div class="flight_fare_info">
                <h3>Fare Summary</h3>
                <div class="more_info_fare">
                  <ul>
                    <li>Base Fare: <span>{{ (this.adultNum * item.multifares[0].flightfare.adultbasefare * this.Xchangerates.getCurrency().rate) + (this.childNum * item.multifares[0].flightfare.childbasefare * this.Xchangerates.getCurrency().rate) + (this.infantNum * item.multifares[0].flightfare.infantbasefare * this.Xchangerates.getCurrency().rate) | globalCurrency: this.Xchangerates.getCurrency().shortname }}</span></li>
                    <li>Fee & Surcharges: <span>{{ (this.adultNum * item.multifares[0].flightfare.adulttax * this.Xchangerates.getCurrency().rate) + (this.childNum * item.multifares[0].flightfare.childtax * this.Xchangerates.getCurrency().rate) + (this.infantNum * item.multifares[0].flightfare.infanttax * this.Xchangerates.getCurrency().rate) | globalCurrency: this.Xchangerates.getCurrency().shortname }}</span></li>
                    <li>Total Amount: <span>{{item.multifares[0].flightfare.totalnet*this.Xchangerates.getCurrency().rate | globalCurrency: this.Xchangerates.getCurrency().shortname}}</span></li>
                  </ul>
                </div>
                <!-- <mat-accordion>
                  <ng-container *ngFor="let itemList of item['multifares']; let i = index;">
                    <mat-expansion-panel [expanded]="step === i" (opened)="setStep(i)" [disabled]="!(item.multifares?.length !== 1)">
                      <mat-expansion-panel-header>
                        <mat-panel-title>{{ itemList?.faretype?.[0]?.name ? (itemList?.faretype?.[0]?.name) : 'Fare Summary' }}</mat-panel-title>
                      </mat-expansion-panel-header>
                      <ng-template matExpansionPanelContent>
                        <div class="more_info_fare">
                          <ul>
                            <li>Base Fare: <span>{{ (this.adultNum * itemList.flightfare.adultbasefare * this.Xchangerates.getCurrency().rate) + (this.childNum * itemList.flightfare.childbasefare * this.Xchangerates.getCurrency().rate) + (this.infantNum * itemList.flightfare.infantbasefare * this.Xchangerates.getCurrency().rate) | globalCurrency: this.Xchangerates.getCurrency().shortname }}</span></li>
                            <li>Fee & Surcharges: <span>{{ (this.adultNum * itemList.flightfare.adulttax * this.Xchangerates.getCurrency().rate) + (this.childNum * itemList.flightfare.childtax * this.Xchangerates.getCurrency().rate) + (this.infantNum * itemList.flightfare.infanttax * this.Xchangerates.getCurrency().rate) | globalCurrency: this.Xchangerates.getCurrency().shortname }}</span></li>
                            <li>Total Amount: <span>{{itemList.flightfare.totalnet*this.Xchangerates.getCurrency().rate | globalCurrency: this.Xchangerates.getCurrency().shortname}}</span></li>
                          </ul>
                        </div> 
                      </ng-template>
                    </mat-expansion-panel>
                  </ng-container>
                </mat-accordion> -->
              </div>
            </div>
            <div class="innerWrapper" *ngIf="!(item | extractValidatingCarrier)?.includes('')">
              <div class="flight_fare_rule">
                <div class="d-flex justify-content-between align-items-baseline">
                  <h3 class="w-100 d-flex justify-content-between align-items-center">Fare Rules
                  <div class="fundInfo" ngClass="{{item.extra_info.refundable === true ? 'refundable' : item.extra_info.refundable === false ? 'non_refundable' : item.extra_info.refundable}}" (click)="flightInfo(i)">
                    {{item.extra_info.refundable === true ? 'REFUNDABLE' : item.extra_info.refundable === false ? 'NON REFUNDABLE' : item.extra_info.refundable}}
                  </div></h3>
                </div>
                <div class="more_info_rule">
                  <ul>
                    <li *ngIf="item.extra_info.cancel.length > 0">Airline Cancellation Fee: <span>{{item.extra_info.cancel[0].value*this.Xchangerates.getCurrency().rate | globalCurrency: this.Xchangerates.getCurrency().shortname}}</span>
                      <p>{{item.extra_info.cancel[0].rule}}</p>
                    </li>
                    <li *ngIf="item.extra_info.change.length > 0">Airline Date Change Fee: <span>{{item.extra_info.change[0].value*this.Xchangerates.getCurrency().rate | globalCurrency: this.Xchangerates.getCurrency().shortname}}</span>
                      <p>{{item.extra_info.change[0].rule}}</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
      </mat-card>
      <ng-container *ngIf="item.name === 'banner'">
        <mat-card class="flight_list_banner">
          <div class="banner_list">
            <div class="bannerImageWrapper">
              <img [src]="item.banner_image" [alt]="item.banner_airline_name" class="img-fluid" appCheckDomain>
            </div>
            <div class="bannerContent"></div>
          </div>
        </mat-card>
      </ng-container>
    </ng-container>
    <div id="togglebtn" class="isobtn" *ngIf="router.url.includes('/cheap-flights')">
      <button mat-button class="view_Fairs__ " color="primary" (click)="toggleFlights()">
        {{ showAllFlights ? 'View Less' : 'View More' }}
      </button>
    </div>
    <!-- <ng-container *ngIf="this.flight_list.length === 0"> -->
      <!-- <app-no-flight *ngIf="!isLoading"></app-no-flight> -->
    <!-- </ng-container> -->
  </ng-container>


  
</section>
